import { feature as accountRecoveryFeature } from '@central-products/account-recovery-flow';
import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';

export const accountRecoveryPlugin = {
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(accountRecoveryFeature);
  },
  postBootstrap({ bootstrapperFeatures }) {
    bootstrapperFeatures['account-actions'].onActionRequested(({ actionId }) => {
      if (actionId === ACCOUNT_ACTION_IDS.RECOVER_START || actionId === ACCOUNT_ACTION_IDS.REOPEN_START) {
        bootstrapperFeatures['account-recovery-flow'].start();
      }
    });
  },
};
